import tw, { styled } from 'twin.macro'
import ReactCalendar from 'react-calendar'
import type { CalendarProps } from 'react-calendar'

const CalendarStyles = styled.div`
  .react-calendar {
    ${tw`
      w-72
      max-w-full
      bg-default-subdued
      font-brand
      text-default-neutral
    `}
  }
  .react-calendar--doubleView {
    width: 700px;
  }
  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }
  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: 0.5em;
  }
  .react-calendar button {
    outline: none;
  }
  .react-calendar__navigation {
    ${tw`
      flex
      space-x-2
      mb-2
    `}
  }
  .react-calendar__navigation button {
    min-width: 44px;
    ${tw`
      rounded-lg
    `}
  }
  .react-calendar__navigation__arrow {
    ${tw`
      text-default-muted
      text-center
    `}
  }
  .react-calendar__navigation__arrow svg {
    display: inline;
  }
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    ${tw`bg-default-neutral`}
  }
  .react-calendar__navigation button[disabled] {
    ${tw`
      opacity-50
      cursor-default
    `}
  }
  .react-calendar__navigation__label__labelText {
    ${tw`
      text-lg
      font-medium
    `}
  }
  .react-calendar__month-view__weekdays {
    ${tw`
      text-center
      font-brand
      text-default-subdued
      text-sm
    `}
  }
  .react-calendar__month-view__weekdays abbr {
    ${tw`no-underline`}
  }
  .react-calendar__month-view__weekdays__weekday {
    ${tw`p-2`}
  }
  .react-calendar__month-view__days__day--neighboringMonth {
    ${tw`text-default-subdued`}
  }
  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    ${tw`
      py-8
      px-2
    `}
  }
  .react-calendar__tile {
    ${tw`
      font-medium
      rounded-full
      bg-none
      p-2
      text-center
      max-w-full
    `}
  }
  .react-calendar__tile:disabled {
    ${tw`
      opacity-50 cursor-default
    `}
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    ${tw`bg-default-neutral`}
  }
  .react-calendar__tile--now {
    // Using box-shadow as an "inner border" so we don't break the layout
    box-shadow: inset 0px 0px 0px 2px #c3d7fe;
    ${tw`
      rounded-full
    `}
  }
  .react-calendar__tile--hasActive {
    ${tw`
      text-brand-neutral
      bg-brand-subdued
      font-bold
    `}
  }
  .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__tile--hasActive:enabled:focus {
    ${tw`bg-brand-muted`}
  }
  .react-calendar__tile--active {
    ${tw`
      rounded-full
      text-brand-neutral
      bg-brand-subdued
      font-bold
      transition-all
    `}
  }
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    ${tw`bg-brand-muted`}
  }
  .react-calendar--selectRange .react-calendar__tile--hover {
    ${tw`bg-default-neutral`}
  }

  .react-calendar__year-view .react-calendar__tile {
    ${tw`py-8 px-2`}
    aspect-ratio: 1/1;
  }

  @supports not (aspect-ratio: 1/1) {
    .react-calendar__year-view .react-calendar__tile {
      position: relative;
      padding: 0;

      &:after {
        content: '';
        display: block;
        padding-bottom: 100%;
      }

      abbr {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
`

export function StyledCalendar(props: CalendarProps) {
  return (
    <CalendarStyles>
      <ReactCalendar {...props} />
    </CalendarStyles>
  )
}
